<template>
	<!-- 特約商品 -->
	<div class="toyakiContainer sort-item">
		<template
			v-if="ptInitData.productInfo.TOKU_TANKA_SITEM != '' && ptInitData.productInfo.TOKU_TANKA_SITEM != undefined && ptInitData.siteFlg == 1">
			<span class="itemIconSp">
				<font class="itemIconStarSp" color="gold">{{ $t('pt125.labels.star') }}</font>
				<font class="itemIconNmSp" color="#ff0033" style="font-size:11px;">
					{{ $t('pt125.labels.productSpecial') }}</font>
			</span>
			<br>
		</template>
		<template v-for="i in 15">
			<span :class="'itemIcon' + (i < 10 ? '0' : '') + i" v-if="ptInitData.productInfo[`ITEM_STATUS${i}`] == 0"
				:key="i">
				<font :class="'itemIconStar' + (i < 10 ? '0' : '') + i" color="gold">
					{{ $t('pt125.labels.star') }}</font>
				<font :class="'itemIconNm' + (i < 10 ? '0' : '') + i" color="#ff0033" style="font-size:11px;">{{
					ptInitData.productInfo[`ICON_NM${i}`] }}</font>
			</span>
		</template>
	</div>
</template>
<script>
export default {
	name: 'toyakiContainer',
	props: {
		ptInitData: {
			type: Object,
			default: null
		}
	}
}
</script>